import React from 'react';
import { useViewerStore } from '@store/viewerModule/base';
import AdvanceDetails from './AdvanceDetails';

function AdvancedSessionDetails() {
  const [{ showAdvanceDetails }] = useViewerStore();
  if (!showAdvanceDetails) {
    return null;
  }
  return (
    <AdvanceDetails />
  );
}

export default AdvancedSessionDetails;
